import { Route, Routes, Navigate } from 'react-router-dom';
import router from './router';
import { useDispatch } from 'react-redux';
import { headerActions } from '@/reducers/HeaderConfig';
import { setDocumentTitle, isEnv } from '@/utils';
interface InitProps {
  children: any; //组件
  meta?: any; //附加参数
}
/**
 * @description: 鉴定login权限  设置header title
 */
const Auth = (props: InitProps) => {
  const {
    children,
    meta: { title, isHeader },
  } = props;
  const dispatch = useDispatch();
  dispatch(
    headerActions.setHeader({
      title,
      isHeader,
      className: '',
      theme: 'white',
    }),
  );
  //H5 情况下设置标题
  if (isEnv() !== 'App') {
    setDocumentTitle(title);
  }
  return children;
};
const initRouter = () => (
  <Routes>
    {router.map((item: any, index: number) => {
      return (
        <Route key={index} path={item.path}>
          {/* 可选参数 */}
          {item.meta.optional &&
            item.meta.optional.map((el: string, idx: number) => (
              <Route
                key={idx}
                path={`:${el}`}
                element={
                  <Auth meta={item.meta}>
                    <item.element />
                  </Auth>
                }
              />
            ))}
          <Route
            path=""
            element={
              <Auth meta={item.meta}>
                <item.element />
              </Auth>
            }
          />
        </Route>
      );
    })}
    <Route path="*" element={<Navigate to="/error/not404" replace />} />
  </Routes>
);
export default initRouter;
